import ApiService from '../api.service';

const Alerts = {
  alertsIndisciplineAndHeatlh: (params) => ApiService.query('/api/v2/teachers/me/student_occurrences/alerts_graph_indiscipline_and_health', params),
  alertsSocioemotional: (params) => ApiService.query('/api/v2/teachers/me/student_occurrences/alerts_graph_socioemotional', params),
  socioemotionalAverageByCategory: (params) => ApiService.query('/api/v2/teachers/me/student_occurrences/socioemotional_average_by_category', params),
};

export default Alerts;
